/**
 * authDocClass.js — TEST 3.19, client half (patient push 3a). What a document uploaded for a
 * visit's authorization IS, as the extractor said, and nothing more.
 *
 * ★★★ THE DEFECT (Alex, testing 2026-09-30, Kaiser HMO check-in). An After Visit Summary from
 *   another visit was accepted as "REFERRAL DETECTED · Processed", with referral details filled
 *   from it, and offered "Save to my case". AuthorizationsScreen did
 *       const dtype = res.documentType === 'authorization' ? 'authorization' : 'referral'
 *   so ANYTHING that was not an authorization became a referral on the client, whatever the
 *   extractor said. (The extractor itself, /ai/extract-document 'auto', is forced to pick one of
 *   the two today: the API half, B10 / D3, gives it a third outcome, 'other', with a reason.)
 *
 * ★★ THE RULE: a referral only when the extractor says 'referral'; an authorization only when it
 *   says 'authorization'; everything else — 'other', a missing type, anything unknown — is
 *   'other', and the screen files nothing. Safe on today's API (which never says 'other') and on
 *   the next one.
 *
 * Pure. scripts/check-auth-upload-classify.mjs executes it.
 */
export function classifyAuthUpload(res) {
  const t = String((res && res.documentType) || '').trim().toLowerCase()
  if (t === 'authorization') return 'authorization'
  if (t === 'referral') return 'referral'
  return 'other'
}
